(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.v3-carousel').forEach(initCarousel);
  });

  function initCarousel(carousel) {
    var trackWrap = carousel.querySelector('.v3-carousel-track-wrap');
    var track     = carousel.querySelector('.v3-carousel-track');
    var btnPrev   = carousel.querySelector('.v3-arrow--prev');
    var btnNext   = carousel.querySelector('.v3-arrow--next');

    if (!track) return;

    var slides = Array.from(track.querySelectorAll('.v3-slide'));
    var total  = slides.length;
    if (total === 0) return;

    var current    = total >= 3 ? 1 : 0;
    var activeW    = 0;
    var sideW      = 0;
    var GAP        = 12;
    var isDragging = false;
    var dragStartX = 0;
    var dragCurX   = 0;
    var THRESHOLD  = 50;

    /* ── Measure ── */
    function measure() {
      var wrapW = trackWrap.offsetWidth;
      if (total === 1) {
        activeW = Math.round(wrapW * 0.76);
        sideW   = 0;
      } else {
        activeW = Math.round(wrapW * 0.50);
        sideW   = Math.round(wrapW * 0.22);
      }
    }

    /* ── Apply pixel widths to every slide ── */
    function applyWidths() {
      slides.forEach(function (s, i) {
        s.style.width = (i === current ? activeW : sideW) + 'px';
      });
    }

    /* ── Compute track X so current slide is centred ── */
    function computeX(delta) {
      var wrapW  = trackWrap.offsetWidth;
      var offset = 0;
      for (var i = 0; i < current; i++) {
        offset += sideW + GAP;
      }
      return Math.round((wrapW - activeW) / 2) - offset + (delta || 0);
    }

    function setTrack(delta, animated) {
      track.style.transition = animated
        ? 'transform 0.42s cubic-bezier(0.25,0.46,0.45,0.94)'
        : 'none';
      track.style.transform = 'translateX(' + computeX(delta) + 'px)';
    }

    /* ── Pause a slide's video and restore its poster ── */
    function pauseSlide(slide) {
      if (!slide) return;
      var wrap   = slide.querySelector('.v3-video-wrap');
      var video  = slide.querySelector('video');
      var poster = slide.querySelector('.v3-poster');
      if (video && !video.paused) {
        video.pause();
      }
      video && video.removeAttribute('controls');
      if (wrap)   wrap.classList.remove('is-playing');
      if (poster) poster.style.display = '';
    }

    /* ── Navigate ── */
    function goTo(idx) {
      if (idx < 0 || idx >= total) return;
      pauseSlide(slides[current]);
      slides[current].classList.remove('is-active');
      current = idx;
      slides[current].classList.add('is-active');
      applyWidths();
      setTrack(0, true);
      updateArrows();
    }

    /* ── Arrows ── */
    function updateArrows() {
      if (btnPrev) btnPrev.disabled = (current === 0);
      if (btnNext) btnNext.disabled = (current === total - 1);
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

    /* ── Drag (desktop) ── */
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDragging = true;
      dragStartX = e.clientX;
      dragCurX   = e.clientX;
      track.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      dragCurX = e.clientX;
      setTrack(dragCurX - dragStartX, false);
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';
      var delta = dragCurX - dragStartX;
      if      (delta < -THRESHOLD) goTo(current + 1);
      else if (delta >  THRESHOLD) goTo(current - 1);
      else                         setTrack(0, true);
    });

    /* ── Swipe (touch) ── */
    var touchStartX = 0;
    var touchCurX   = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchCurX   = touchStartX;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      touchCurX = e.touches[0].clientX;
      setTrack(touchCurX - touchStartX, false);
    }, { passive: true });

    track.addEventListener('touchend', function () {
      var delta = touchCurX - touchStartX;
      if      (delta < -THRESHOLD) goTo(current + 1);
      else if (delta >  THRESHOLD) goTo(current - 1);
      else                         setTrack(0, true);
    });

    /* ── Play / pause button ── */
    carousel.addEventListener('click', function (e) {
      var btn = e.target.closest('.v3-play-btn');
      if (!btn) return;

      var slide    = btn.closest('.v3-slide');
      if (!slide) return;

      var slideIdx = slides.indexOf(slide);

      /* Side slide tap — navigate to it first, second tap plays */
      if (slideIdx !== current) {
        goTo(slideIdx);
        return;
      }

      var wrap   = slide.querySelector('.v3-video-wrap');
      var poster = slide.querySelector('.v3-poster');
      var video  = slide.querySelector('video');

      if (!video) {
        console.warn('v3-carousel: no <video> found in slide', slideIdx);
        return;
      }

      /* If playing — pause it */
      if (!video.paused) {
        video.pause();
        return;
      }

      /* Otherwise — play it */
      if (poster) poster.style.display = 'none';
      if (wrap)   wrap.classList.add('is-playing');

      if (video.readyState === 0) video.load();
      video.setAttribute('controls', 'controls');

      var promise = video.play();
      if (promise && promise.catch) {
        promise.catch(function (err) {
          console.warn('v3-carousel: play() blocked —', err.message);
        });
      }
    });

    /* ── Restore poster on pause / end ── */
    carousel.addEventListener('pause', onVideoStop, true);
    carousel.addEventListener('ended', onVideoStop, true);

    function onVideoStop(e) {
      if (!e.target || e.target.tagName !== 'VIDEO') return;
      var slide  = e.target.closest('.v3-slide');
      var wrap   = e.target.closest('.v3-video-wrap');
      var poster = slide ? slide.querySelector('.v3-poster') : null;
      e.target.removeAttribute('controls');
      if (wrap) wrap.classList.remove('is-playing');
      if (e.type === 'ended') e.target.currentTime = 0;
      if (poster) poster.style.display = '';
    }

    /* ── Init ── */
    measure();
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    slides[current].classList.add('is-active');
    applyWidths();
    setTrack(0, false);
    updateArrows();

    requestAnimationFrame(function () {
      track.style.transition = '';
    });

    /* ── Resize ── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        measure();
        applyWidths();
        setTrack(0, false);
        requestAnimationFrame(function () { track.style.transition = ''; });
      }, 150);
    });
  }

}());
